import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { /* BrowserRouter, */ HashRouter } from "react-router-dom";

import reportWebVitals from "./reportWebVitals";

import "./i18n";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    {/*<BrowserRouter> */}
    {/*<BrowserRouter basename="/divers/travaux_ID-Formation/annuaire4k"> */}
    {/*<HashRouter basename="/divers/travaux_ID-Formation/annuaire4k"> */}
    <HashRouter>
      <App />
    </HashRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
